import React from "react";
import { useTranslation } from "react-i18next";
import { PROBLEM_IMAGE } from "../../lib/assets";

export const ProblemSolution = () => {
  const { t } = useTranslation();
  const problems = t("problemSolution.problems", { returnObjects: true }) || [];
  const solutions = t("problemSolution.solutions", { returnObjects: true }) || [];

  return (
    <section
      data-testid="problem-solution-section"
      className="relative bg-background py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:gap-20 lg:px-10">
        <div className="relative lg:col-span-5">
          <div className="overflow-hidden rounded-[2rem] border border-[hsl(var(--border))]">
            <img
              src={PROBLEM_IMAGE}
              alt="EquiSight"
              className="h-[420px] w-full object-cover transition-transform duration-700 hover:scale-[1.04] sm:h-[560px]"
            />
          </div>
          <div className="absolute -bottom-6 left-6 right-6 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-5 shadow-sm sm:left-auto sm:right-0 sm:max-w-xs">
            <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--ink-soft))]">
              {t("problemSolution.noteToday")}
            </p>
            <p className="mt-2 font-display text-xl text-[hsl(var(--ink))]">
              {t("problemSolution.noteText")}
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--sand-dark))]">
            {t("problemSolution.eyebrow")}
          </p>
          <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] text-[hsl(var(--ink))] text-balance sm:text-5xl lg:text-6xl">
            {t("problemSolution.titleA")}
            <br />
            <span className="italic text-[hsl(var(--sand-dark))]">EquiSight</span> {t("problemSolution.titleB")}
          </h2>

          <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2">
            <div>
              <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--ink-soft))]">
                {t("problemSolution.today")}
              </p>
              <ul className="mt-4 space-y-3 text-[hsl(var(--ink-soft))]">
                {problems.map((p) => (
                  <li key={p} className="flex gap-3">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[hsl(var(--ink-soft))]/60" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-2xl border border-[hsl(var(--forest))]/15 bg-[hsl(var(--surface-secondary))] p-6">
              <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--forest))]">
                {t("problemSolution.withEquiSight")}
              </p>
              <ul className="mt-4 space-y-3 text-[hsl(var(--ink))]">
                {solutions.map((s) => (
                  <li key={s} className="flex gap-3">
                    <span className="mt-1.5 grid h-4 w-4 shrink-0 place-items-center rounded-full bg-[hsl(var(--forest))] text-[10px] text-[hsl(var(--background))]">
                      ✓
                    </span>
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
